module.exports = __webpack_public_path__ + "media/images/coclick-logo-short-white-h30-4ff4ca04460b0629490f56002302ed25.png";